import axios from 'axios';
import _ from 'lodash';
import DomainNameAPI from '../constants/DomainNameAPI';
import LoginService from '../utils/login-service';
import Topics from '../constants/Topics';
import Constants from '../constants/Constants';
import ReactDOM from 'react-dom';

const apiError = Constants.API_SERVER_ERROR;

export let copyOptions = (argsObject) => {
  //this service returns a value because another service depends on it
  //args are: orgId, ap
  // let orgId = parseInt(event.queryStringParameters['orgId']);
  // let application = event.queryStringParameters['application'];
  // let year = event.queryStringParameters['year'];
  // let optionSetId = event.queryStringParameters['optionSetId'];
  // let description = event.queryStringParameters['description'];

  if (_.isNil(argsObject.orgId) || _.isNil(argsObject.Api)) {
    throw new Error('copyOptions call requires orgId and Api');
  }

  let varEnv = process.env.REACT_APP_STAGE; //eslint-disable-line no-undef
  let baseUrl = DomainNameAPI[varEnv].COPY_SERVICE_BASEURL;
  let options = `orgId=${argsObject.orgId}&year=${argsObject.year}&application=${argsObject.application}&optionSetId=${argsObject.optionSetId}&clientDescription=${argsObject.description}&inValidCaching=false`; //eslint-disable-line no-undef

  let url = `${baseUrl}${options}`;
  return axios({
    method: 'GET',
    url: url,
    timeout: 15000,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CB-Catapult-Authentication-Token': 'CBLogin ' + LoginService.getTokens().sessionId,
      'X-CB-Catapult-Authorization-Token': LoginService.getTokens().token,
    },
  })
    .then((res) => {
      argsObject.Api.Publish(Topics.OPTIONS_USER_DATA, res.data);
      argsObject.Api.Publish(Topics.IS_LOADING, { isLoading: false });
      return res.data;
    })
    .catch((err) => {
      console.log(err);
      argsObject.Api.Publish(Topics.API_ERROR, { apiError: true });
    });
};

export let updateDesc = (argsObject) => {
  if (_.isNil(argsObject.orgId) || _.isNil(argsObject.Api)) {
    throw new Error('updateDesc call requires orgId and Api');
  }

  let varEnv = process.env.REACT_APP_STAGE; //eslint-disable-line no-undef
  let baseUrl = DomainNameAPI[varEnv].DESC_SERVICE_BASEURL;
  let options = `orgId=${argsObject.orgId}&year=${argsObject.year}&application=${argsObject.application}&optionSetId=${argsObject.optionSetId}&clientDescription=${argsObject.description}&inValidCaching=false`; //eslint-disable-line no-undef

  let url = `${baseUrl}${options}`;
  return axios({
    method: 'GET',
    url: url,
    timeout: 15000,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CB-Catapult-Authentication-Token': 'CBLogin ' + LoginService.getTokens().sessionId,
      'X-CB-Catapult-Authorization-Token': LoginService.getTokens().token,
    },
  })
    .then((res) => {
      argsObject.Api.Publish(Topics.OPTIONS_USER_DATA, res.data);
      argsObject.Api.Publish(Topics.IS_LOADING, { isLoading: false });
    })
    .catch((err) => {
      console.log(err);
      argsObject.Api.Publish(Topics.API_ERROR, { apiError: true });
    });
};

const showError = (error) => {
  const errorMessage = error;
  ReactDOM.render(
    <div className="Error" style={{ color: 'black' }}>
      <h4>
        {errorMessage && (
          <div style={{ color: 'black' }} className="error">
            {' '}
            {errorMessage}{' '}
          </div>
        )}
      </h4>
    </div>,
    document.getElementById('root')
  );
};
